import { render, staticRenderFns } from "./RulesLeagues.vue?vue&type=template&id=438fe046&scoped=true&"
import script from "./RulesLeagues.vue?vue&type=script&lang=js&"
export * from "./RulesLeagues.vue?vue&type=script&lang=js&"
import style0 from "./RulesLeagues.vue?vue&type=style&index=0&id=438fe046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fe046",
  null
  
)

export default component.exports